import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import React, { ReactElement } from 'react'
import { FastDriverProps } from '../../components/FastDriver'
import { FastFirmProps } from '../../components/FastFirm'
import { FastVehicleProps } from '../../components/FastVehicle'
import { GetCompanyListResponseItem } from '../../models/response/company/GetCompanyListResponse'
import { GetActiveCurrencyConversionsData } from '../../models/response/currencyConversion/GetActiveCurrencyConversions'
import { LoginResponse } from '../../models/response/user/LoginResponse'

export interface authSlice {
    user: UserObject,
    activityIndicator: boolean
    areYouSureModalCallback: (() => void) | undefined
    selectedCompany: GetCompanyListResponseItem | undefined
    companyList: GetCompanyListResponseItem[]
    imageViewer: string[]
    currencyConversionList: GetActiveCurrencyConversionsData[]
    fastFirm: FastFirmProps | undefined
    fastDriver: FastDriverProps | undefined
    fastVehicle: FastVehicleProps | undefined
    ebbeModalCallback: EbbeModalObject | undefined
}

interface UserObject {
    user: LoginResponse | undefined,
    isLoading: boolean,
}

const initialUserObject: UserObject = {
    isLoading: true,
    user: undefined,
}

export interface EbbeModalObject {
    title: string
    body: string
    buttons: EbbeModalObjectButton[]
    onClose?: (() => void) | undefined
    /** Verilirse pencere sade başlık + renkli bilgi kutusu + ayrı soru satırıyla çizilir (17.10.2026); body kullanılmaz. */
    vurgu?: EbbeModalVurgu
}

export interface EbbeModalVurgu {
    renk: 'turuncu' | 'mavi' | 'kirmizi' | 'yesil'
    /** Kutunun renkli üst satırı, ör. "e-Arşiv olarak gidecek". */
    baslik: string
    /** Metnin başında kalın yazılan kısım, ör. alıcı adı. */
    kalin?: string
    metin: string
    /** Kutunun altındaki soru, ör. "Devam edilsin mi?". */
    soru?: string
}

interface EbbeModalObjectButton {
    text: string
    btnClass: string
    onClick?: () => void
}

const initialState: authSlice = {
    user: initialUserObject,
    activityIndicator: false,
    areYouSureModalCallback: undefined,
    selectedCompany: undefined,
    companyList: [],
    imageViewer: [],
    currencyConversionList: [],
    fastFirm: undefined,
    fastDriver: undefined,
    fastVehicle: undefined,
    ebbeModalCallback: undefined
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        storeUser: (state, action: PayloadAction<UserObject>) => {
            state.user = action.payload
        },
        storeActivityIndicator: (state, action: PayloadAction<boolean>) => {
            state.activityIndicator = action.payload;
        },
        storeAreYouSureModalCallback: (state, action: PayloadAction<(() => void) | undefined>) => {
            state.areYouSureModalCallback = action.payload
        },
        storeSelectedCompany: (state, action: PayloadAction<GetCompanyListResponseItem | undefined>) => {
            state.selectedCompany = action.payload
        },
        storeCompanyList: (state, action: PayloadAction<GetCompanyListResponseItem[]>) => {
            state.companyList = action.payload
        },
        storeImageViewer: (state, action: PayloadAction<string[]>) => {
            state.imageViewer = action.payload
        },
        storeCurrencyConversionList: (state, action: PayloadAction<GetActiveCurrencyConversionsData[]>) => {
            state.currencyConversionList = action.payload
        },
        storeFastFirm: (state, action: PayloadAction<FastFirmProps | undefined>) => {
            state.fastFirm = action.payload
        },
        storeFastDriver: (state, action: PayloadAction<FastDriverProps | undefined>) => {
            state.fastDriver = action.payload
        },
        storeFastVehicle: (state, action: PayloadAction<FastVehicleProps | undefined>) => {
            state.fastVehicle = action.payload
        },
        storeEbbeModalCallback: (state, action: PayloadAction<EbbeModalObject | undefined>) => {
            state.ebbeModalCallback = action.payload
        },
        // storeSidebarShow: (state, action: PayloadAction<boolean>) => {
        //     state.sidebarShow = action.payload
        // },
        // storeSidebarUnfoldable: (state, action: PayloadAction<boolean>) => {
        //     state.sidebarUnfoldable = action.payload
        // },
        // storeLanguage: (state, action: PayloadAction<LanguageModelRedux>) => {
        //     state.language = action.payload
        // },
        // storeIsNotificationsOpen: (state, action: PayloadAction<boolean>) => {
        //     state.isNotificationsOpen = action.payload
        // },
        // storeIsCollapsed: (state, action: PayloadAction<boolean>) => {
        //     state.isCollapsed = action.payload
        // },
        // storeThreeDot: (state, action: PayloadAction<ThreeDotModel | undefined>) => {
        //     state.threeDot = action.payload
        // },
    },
})

// Action creators are generated for each case reducer function
export const {
    storeUser,
    storeActivityIndicator,
    storeAreYouSureModalCallback,
    storeSelectedCompany,
    storeCompanyList,
    storeImageViewer,
    storeCurrencyConversionList,
    storeFastFirm,
    storeFastDriver,
    storeFastVehicle,
    storeEbbeModalCallback
} = authSlice.actions

export default authSlice.reducer;